import React from 'react';
import './viewInformationPills.scss';
import GrayTick from '../../../assets/icons/grayTick.png';

interface IViewInformationPills {
    text: string;
}

const ViewInformationPills = ({ text }: IViewInformationPills) => {
    return (
        <div className="viewInformationPills">
            <img src={GrayTick} alt="" className='grayTick'/>
            {text}
        </div>
    );
};

export default ViewInformationPills;
